import React, { useEffect } from 'react';
import { Col, Input, Row, Label } from 'reactstrap';
import OSelect from '../../../Components/OElements/OSelect';
import { useDispatch } from 'react-redux';
import { getFlowRateUnitList } from '../../../slices/thunks';

const DECIMAL_INPUT = /^\d*\.?\d*$/;

const displayDecimal = (value) =>
	value === null || value === undefined || value === '' ? '' : String(value);

const FlowInformation = ({ validation }) => {
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(getFlowRateUnitList());
	}, [dispatch]);

	const handleDecimalInput = (name) => (e) => {
		const raw = e.target.value.replace(',', '.');
		if (raw === '' || DECIMAL_INPUT.test(raw)) {
			validation.setFieldValue(name, raw);
		}
	};

	const handleAnnualFlowToggle = (checked) => {
		validation.setFieldValue('has_annual_average_flow', checked);
		if (!checked) {
			validation.setFieldValue('annual_average_flow', '');
			validation.setFieldValue('flow_rate_unit_id', '');
			validation.setFieldTouched('annual_average_flow', false);
			validation.setFieldTouched('flow_rate_unit_id', false);
		}
	};

	const handleEcologicalFlowToggle = (checked) => {
		validation.setFieldValue('has_ecological_flow', checked);
		if (!checked) {
			validation.setFieldValue('ecological_flow', '');
			validation.setFieldTouched('ecological_flow', false);
		} else {
			validation.setFieldTouched('ecological_flow', true);
		}
	};

    return (
        <React.Fragment>
                <div>
                    <h5>Información Del Caudal</h5>
                    <p className="text-muted"></p>
                </div>
                
                <div>
                    <Row className='gx-2 align-items-center'>
						<Col>
							<div className="form-check form-switch form-switch-md">
								<Input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    role="switch" 
                                    id="has_annual_average_flow"
                                    name="has_annual_average_flow"
                                    checked={validation.values.has_annual_average_flow || false}
                                    onChange={(e) => handleAnnualFlowToggle(e.target.checked)}
                                />
								<Label className="form-check-label" for="has_annual_average_flow">¿Caudal Promedio Anual?</Label>
							</div>
						</Col>
						<Col className='mb-3'>
                            <Label for='annual_average_flow' className='form-label'>
                                Caudal Anual Promedio
                                {validation.values.has_annual_average_flow && <span className="text-danger"> *</span>}
                            </Label>
                            <Input
                                name='annual_average_flow'
                                id='annual_average_flow'
                                className='form-control'
                                placeholder='Ingrese Caudal Anual Promedio'
                                type='text'
                                inputMode='decimal'
                                value={displayDecimal(validation.values.annual_average_flow)}
                                onChange={handleDecimalInput('annual_average_flow')}
                                onBlur={validation.handleBlur}
                                disabled={!validation.values.has_annual_average_flow}
                                invalid={validation.touched.annual_average_flow && validation.errors.annual_average_flow}
                            />
                            {validation.touched.annual_average_flow && validation.errors.annual_average_flow && (
                                <div className='invalid-feedback'>{validation.errors.annual_average_flow}</div>
                            )}
                        </Col>
						<Col className='mb-3'>
                            <OSelect
                                key={validation.values.flow_rate_unit_id || ''}
                                label="Unidad De Caudal"
                                id="flow_rate_unit_id"
                                name="flow_rate_unit_id"
                                value={validation.values.flow_rate_unit_id || ''}
                                requestApi={() => dispatch(getFlowRateUnitList()).then(res => res.payload)}
                                validation={validation}
                                disabled={!validation.values.has_annual_average_flow}
                                isRequired={validation.values.has_annual_average_flow}
                            />
                        </Col>
						<Col>
							<div className="form-check form-switch form-switch-md">
								<Input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    role="switch" 
                                    id="has_ecological_flow"
                                    name="has_ecological_flow"
                                    checked={validation.values.has_ecological_flow || false}
                                    onChange={(e) => handleEcologicalFlowToggle(e.target.checked)}
                                />
								<Label className="form-check-label" for="has_ecological_flow">¿Caudal Ecológico Promedio?</Label>
							</div>
						</Col>
						<Col className='mb-3'>
                            <Label for='ecological_flow' className='form-label'>
                                Caudal Ecológico (l/s)
                                {validation.values.has_ecological_flow && <span className="text-danger"> *</span>}
                            </Label>
                            <Input
                                name='ecological_flow'
                                id='ecological_flow'
                                className='form-control'
                                placeholder='Ingrese Caudal Ecológico (l/s)'
                                type='text'
                                inputMode='decimal'
                                value={displayDecimal(validation.values.ecological_flow)}
                                onChange={handleDecimalInput('ecological_flow')}
                                onBlur={validation.handleBlur}
                                disabled={!validation.values.has_ecological_flow}
                                invalid={validation.touched.ecological_flow && validation.errors.ecological_flow}
                            />
                            {validation.touched.ecological_flow && validation.errors.ecological_flow && (
                                <div className='invalid-feedback'>{validation.errors.ecological_flow}</div>
                            )}
                        </Col> 
                    </Row>
                </div>
        </React.Fragment>
    )
}

export default FlowInformation;
